/** Capitalized-but-generic words that are NOT sensitive and shouldn't initial. */
const GENERIC_CAPITALIZED = new Set([
    "pitch", "meeting", "call", "lunch", "dinner", "coffee", "sync", "standup",
    "review", "prep", "pickup", "dropoff", "appointment", "appt", "the", "a", "an",
]);
/** Reduce a proper noun to initials: "Richard" → "R.", "Coral Springs" → "C. S." */
export function toInitials(word) {
    return word
        .split(/\s+/)
        .filter(Boolean)
        .map((w) => {
        const first = w.match(/[A-Za-z]/)?.[0];
        return first ? `${first.toUpperCase()}.` : w;
    })
        .join(" ");
}
function isProperNoun(token, index, known) {
    const bare = token.replace(/[^A-Za-z]/g, "");
    if (!bare)
        return false;
    if (known.has(bare.toLowerCase()))
        return true;
    if (GENERIC_CAPITALIZED.has(bare.toLowerCase()))
        return false;
    // All-caps acronyms (ESG, DOCK) are almost always org names → redact.
    if (bare.length >= 2 && bare === bare.toUpperCase())
        return true;
    // Capitalized word that isn't the first word of the title → likely a name.
    // Test the punctuation-stripped form so a trailing comma doesn't hide a name.
    if (index > 0 && /^[A-Z]/.test(token) && /^[A-Z][a-z]/.test(bare))
        return true;
    return false;
}
/** Apply initials redaction to a free-text title. */
export function redactToInitials(title, opts = {}) {
    const known = new Set((opts.knownEntities ?? []).map((e) => e.toLowerCase()));
    const tokens = title.split(/(\s+)/); // keep whitespace tokens
    let wordIndex = -1;
    return tokens
        .map((tok) => {
        if (/^\s+$/.test(tok) || tok === "")
            return tok;
        wordIndex += 1;
        if (isProperNoun(tok, wordIndex, known)) {
            // Preserve trailing punctuation (e.g. a comma) after the initials.
            const trailing = tok.match(/[^A-Za-z]+$/)?.[0] ?? "";
            const core = trailing ? tok.slice(0, -trailing.length) : tok;
            return toInitials(core) + trailing;
        }
        return tok;
    })
        .join("");
}
/** Redact a single event's spoken label to the given level. */
export function redactEvent(ev, level, opts = {}) {
    switch (level) {
        case "open":
            return ev.title;
        case "initials":
            return redactToInitials(ev.title, opts);
        case "opaque":
            return ev.important
                ? `Your ${ev.startLabel} — the big one. Details in the app.`
                : `Your ${ev.startLabel}. Details in the app.`;
    }
}
/**
 * Resolve the effective level for an event: a calendar pinned to `opaque`
 * (sensitive calendars, §7.3) always wins over the profile default.
 */
export function effectiveLevel(profileDefault, calendarPinnedOpaque) {
    return calendarPinnedOpaque ? "opaque" : profileDefault;
}
//# sourceMappingURL=redact.js.map